import React from 'react';

import { Paper, useTheme, Typography } from '@mui/material';

import useAuth from 'src/hooks/useAuth';
import useLocales from 'src/hooks/useLocales';
import useResponsive from 'src/hooks/useResponsive';

import { Permissions } from '../../@types/auth/constants/permissions';
import PermissionCheck from '../../components/access-checks/PermissionCheck';
import DocumentsUploadWidget from '../documents/upload/DocumentsUploadWidget';

//---------------------------------------------------

export default function DashboardWelcomeUpload() {
  const { t } = useLocales();
  const isMobile = useResponsive('down', 'sm');
  const { user } = useAuth();
  const theme = useTheme();

  return (
    <Paper
      sx={{
        width: `100%`,
        py: { xs: 1.5, sm: 2 },
        px: { xs: 2, sm: 4 },
        margin: 'auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
        gap: 2,
        borderRadius: '16px',
        backgroundColor: theme.palette.secondary.main,
        backgroundImage: 'url(/images/dlx_bg_pattern.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
      elevation={3}
    >
      <Typography variant={isMobile ? 'h6' : 'h5'} sx={{ color: theme.palette.grey[100] }}>
        {user ? t('dashboard.welcomeName', { userName: user?.firstName }) : t('dashboard.welcome')}
      </Typography>
      <PermissionCheck permissions={[Permissions.ComposeDocument]}>
        <DocumentsUploadWidget />
      </PermissionCheck>
    </Paper>
  );
}
